"use client";

import React, { memo, useState } from "react";
import { Heading } from "app/_components/components/Text/Heading";
import { Body } from "app/_components/components/Text/Body";
import {
  AccordionBody,
  AccordionBox,
  AccordionContent,
  AccordionHeader
} from "./FaqAccordion.styled";
import type { AccordionProps, ContentProps } from "types/prices";
import { ContentfulResponsiveImage } from "components/common/image/ContentfulResponsiveImage";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const FaqAccordion = (props: AccordionProps) => {
  const { title, content } = props?.accordion || {};
  const [activeAccordionIdx, setActiveAccordionIdx] = useState(0);

  const handleAccordion = (idx: number) => {
    setActiveAccordionIdx(activeAccordionIdx === idx ? 0 : idx);
  };

  return (
    <AccordionContent>
      {title && (
        <Heading
          size="md"
          className="mb-8 !leading-[28px] !font-medium !tracking-[-0.5px]"
        >
          {title}
        </Heading>
      )}
      {content &&
        content.length > 0 &&
        content.map((data: ContentProps, index: number) => {
          return (
            <AccordionBox
              key={index}
              isCollapsed={Boolean(index === activeAccordionIdx)}
            >
              <AccordionHeader onClick={() => handleAccordion(index)}>
                <Heading size="xs" className="m-0">
                  {data?.question}
                </Heading>
                {data?.image?.url && (
                  <ContentfulResponsiveImage
                    alt={data?.image?.altText ?? ""}
                    sizes={[
                      {
                        media: "(min-width: 0)",
                        src: data?.image?.url,
                        height: data?.image?.height || 24,
                        width: data?.image?.width || 24
                      }
                    ]}
                  />
                )}
              </AccordionHeader>
              <AccordionBody className="accBody">
                <Body size="sm" as="div" className="m-0">
                  {data?.answer && documentToReactComponents(data?.answer)}
                </Body>
              </AccordionBody>
            </AccordionBox>
          );
        })}
    </AccordionContent>
  );
};

export default memo(FaqAccordion);
